import { render } from "./ViewedContacts.vue?vue&type=template&id=313331b8"
import script from "./ViewedContacts.vue?vue&type=script&lang=js"
export * from "./ViewedContacts.vue?vue&type=script&lang=js"

import exportComponent from "D:\\MY PROJECTS\\Vue 3 Project\\MarriageBeauroWeb\\marriage_beauro_web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__